import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from '../../../../../../../shared/services/helpers/message-service/message.service';
import { ShootProofDataProvider } from '../../../../../../../shared/services/integrations/shootProof/shootProof.data.service';
import { InvoicesDataProvider } from '../../../../../../../shared/services/invoice/invoices-data-service/invoices.data.service';

@Component({
	selector: 'delete-confirmation-modal',
	template: require('./delete-confirmation.modal.html'),
	styles: [require('./delete-confirmation.modal.scss')]
})
export class DeleteConfirmationModal {
	@Input('deleteGalleryId')
	set deleteGalleryId(value) {
		this._deleteGalleryId = value;
	}
	get deleteGalleryId() {
		return this._deleteGalleryId;
	}

	_deleteGalleryId: number;
	deleteGalleryFromShootProofAndSNSpinner = false;
	@Output('deleteEvent') deleteEvent = new EventEmitter<any>();

	constructor(
		private shootProofDataService: ShootProofDataProvider,
		private messageService: MessageService
	) {}

	deleteGalleryFromShootProofAdnSN() {
		this.deleteGalleryFromShootProofAndSNSpinner = true;
		this.deleteGallery();
	}

	private deleteGallery() {
		this.shootProofDataService
			.removeJobGalleryV1(this.deleteGalleryId, true)
			.finally(() => (this.deleteGalleryFromShootProofAndSNSpinner = false))
			.subscribe(
				() => this.successDeleteGallery(),
				error => this.messageService.showDefaultErrorMessage(error)
			);
	}

	private successDeleteGallery() {
		this.deleteEvent.emit();
		this.messageService.showToaster('s_5', 'shootProof');
		$('#deleteConfirmationModal').modal('hide');
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./web/modern/components/integrations/shootProof/modals/delete-confirmation-modal/delete-confirmation.modal..ts